import Vue from 'vue'
import VueRouter from 'vue-router'
import { userKey } from '../global'

Vue.use(VueRouter)

const routes = [{
    name: 'Home',
    path: '/',
    component: () => import(/* webpackChunkName: "home" */ "../components/paginas/Home"),
}, {
    name: 'About',
    path: '/Sobre',
    component: () => import(/* webpackChunkName: "about" */ "../components/paginas/About"),
    props: true
}, {
    name: 'Auth',
    path: '/Login',
    component: () => import(/* webpackChunkName: "auth" */ "../components/paginas/Auth"),
}, {
    name: 'Bms',
    path: '/KinderBMS',
    component: () => import(/* webpackChunkName: "bms" */ "../components/paginas/Bms"),
}, {
    name: 'Contato',
    path: '/Contatos',
    component: () => import(/* webpackChunkName: "contato" */ "../components/paginas/Contato"),
}, {
    name: 'Empilhadeiras',
    path: '/Empilhadeiras',
    component: () => import(/* webpackChunkName: "empilhadeiras" */ "../components/paginas/Empilhadeiras"),
}, {
    name: 'EnergyStorage',
    path: '/EnergyStorage',
    component: () => import(/* webpackChunkName: "energystorage" */ "../components/paginas/EnergyStorage"),
}, {
    name: 'Mobilidade',
    path: '/Eletromobilidade',
    component: () => import(/* webpackChunkName: "mobilidade" */ "../components/paginas/Mobilidade"),
}, {
    name: 'Registro',
    path: '/Registro',
    component: () => import(/* webpackChunkName: "registro" */ "../components/paginas/Registro"),
}, {
    name: 'Smart',
    path: '/SmartHomes',
    component: () => import(/* webpackChunkName: "smart" */ "../components/paginas/Renovavel"),
}, {
    name: 'Renovavel',
    path: '/EnergiaRenovavel',
    component: () => import(/* webpackChunkName: "renovavel" */ "../components/paginas/SmartHome"),
}, {
    name: 'Tecnologia',
    path: '/Tecnologia',
    component: () => import(/* webpackChunkName: "tecnologia" */ "../components/paginas/Tecnologia"),
}, {
    name: 'Maritima',
    path: '/Maritima',
    component: () => import(/* webpackChunkName: "maritima" */ "../components/paginas/Maritima"),
}, {
    name: 'Industria',
    path: '/Industria',
    component: () => import(/* webpackChunkName: "industria" */ "../components/paginas/Industria"),
}, {
    name: 'Agro',
    path: '/Agro',
    component: () => import(/* webpackChunkName: "agro" */ "../components/paginas/Agro"),
}, {
    name: 'Militar',
    path: '/Militar',
    component: () => import(/* webpackChunkName: "militar" */ "../components/paginas/Militar"),
}, {
    name: 'Drones',
    path: '/Drones',
    component: () => import(/* webpackChunkName: "drones" */ "../components/paginas/Drones"),
}, {
    name: 'Telecomunicacoes',
    path: '/Telecomunicacoes',
    component: () => import(/* webpackChunkName: "telecomunicacoes" */ "../components/paginas/Telecomunicacoes"),
}, {
    name: 'Hospitalar',
    path: '/Hospitalar',
    component: () => import(/* webpackChunkName: "hospitalar" */ "../components/paginas/Hospitalar"),
}, {
    name: 'Interativa',
    path: '/PlataformaHION',
    component: () => import(/* webpackChunkName: "interativa" */ "../components/plataforma/Interativa"),
    children: [{
        name: 'HomeInterativa',
        path: '/PlataformaHION/Dashboard',
        component: () => import(/* webpackChunkName: "homeInterativa" */ "../components/plataforma/Home/HomeInterativa"),
    }, {
        name: 'HomeHionSocio',
        path: '/PlataformaHION/Socio',
        component: () => import(/* webpackChunkName: "homeHionSocio" */ "../components/plataforma/Home/HomeHionSocio"),
    }, {
        name: 'HomeHionDev',
        path: '/PlataformaHION/Dev',
        component: () => import(/* webpackChunkName: "homeHionDev" */ "../components/plataforma/Home/HomeHionDev"),
    }, {
        name: 'HomeHionAdm',
        path: '/PlataformaHION/Adm',
        component: () => import(/* webpackChunkName: "homeHionAdm" */ "../components/plataforma/Home/HomeHionAdm"),
    }, {
        name: 'HomeInterativaN1',
        path: '/PlataformaHION/Admin',
        component: () => import(/* webpackChunkName: "homeInterativaN1" */ "../components/plataforma/Home/HomeInterativaN1"),
    }, {
        name: 'HomeInterativaN2',
        path: '/PlataformaHION/perfil',
        component: () => import(/* webpackChunkName: "homeInterativaN2" */ "../components/plataforma/Home/HomeInterativaN2"),
    }, {
        name: 'HomeInterativaN3',
        path: '/PlataformaHION/encarregado',
        component: () => import(/* webpackChunkName: "homeInterativaN3" */ "../components/plataforma/Home/HomeInterativaN3"),
    }, {
        name: 'HomeInterativaN4',
        path: '/PlataformaHION/operador',
        component: () => import(/* webpackChunkName: "homeInterativaN4" */ "../components/plataforma/Home/HomeInterativaN4"),
    },
  
    {
        name: 'BateriaInterativa',
        path: '/PlataformaHION/Baterias',
        component: () => import(/* webpackChunkName: "bateriaInterativa" */ "../components/plataforma/Home/BateriaInterativa"),
    }, {
        name: 'ColaboradorInterativo',
        path: '/PlataformaHION/Colaborador',
        component: () => import(/* webpackChunkName: "colaboradorInterativo" */ "../components/plataforma/Home/ColaboradorInterativo"),
        meta: { requiresAdmin: true }
    }, {
        name: 'FrotaInterativa',
        path: '/PlataformaHION/Frota',
        component: () => import(/* webpackChunkName: "frotaInterativa" */ "../components/plataforma/Home/FrotaInterativa"),
        meta: { requiresAdmin: true }
    }, {
        name: 'OperacaoInterativa',
        path: '/PlataformaHION/Operacao',
        component: () => import(/* webpackChunkName: "OperacaoInterativa" */ "../components/plataforma/Home/OperacaoInterativa"),
        meta: { requiresAdmin: true }
    }, {
        name: 'FinancaInterativa',
        path: '/PlataformaHION/Aquisicoes',
        component: () => import(/* webpackChunkName: "FinancaInterativa" */ "../components/plataforma/Home/FinancaInterativa"),
        meta: { requiresAdmin: true }
    }, {
        name: 'AdminPages',
        path: '/PlataformaHION/Administrador',
        component: () => import(/* webpackChunkName: "AdminPages" */ "../components/plataforma/admin/AdminPages"),
        meta: { requiresAdmin: true }
    }, {
        name: 'SuporteInterativo',
        path: '/PlataformaHION/Suporte',
        component: () => import(/* webpackChunkName: "SuporteInterativo" */ "../components/plataforma/Home/SuporteInterativo"),
    }, {
        name: 'CadastroHion',
        path: '/PlataformaHION/Hion/CadastroHion',
        component: () => import(/* webpackChunkName: "CadastroHion" */ "../components/plataforma/Hion/CadastroHion"),
    }, {
        name: 'CadastroCliente',
        path: '/PlataformaHION/Hion/CadastroCliente',
        component: () => import(/* webpackChunkName: "CadastroCliente" */ "../components/plataforma/Hion/CadastroCliente"),
    }]
}]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition
        } else {
          return { x: 0, y: 0 }
        }
      }
})

router.beforeEach((to, from, next) => {
    const json = localStorage.getItem(userKey)

    if(to.matched.some(record => record.meta.requiresAdmin)) {
        const user = JSON.parse(json)
        user && user.admin ? next() : next({ path: '/' })
    } else {
        next()
    }
})

export default router
